import { TranslateService } from '@ngx-translate/core';

import { CmpsDatePipe } from './common/date.pipe';
import { CmpsDecimalPipe, CmpsPercentPipe } from './common/number.pipe';
import { InsightEpicBridge } from './insight/insight.epic.bridge';

const Types: { [key: string]: { identifier: string; class: any } } = {
    TranslateService: {
        identifier: 'TranslateService',
        class: TranslateService,
    },
    CmpsDatePipe: { identifier: 'CmpsDatePipe', class: CmpsDatePipe },
    CmpsDecimalPipe: { identifier: 'CmpsDecimalPipe', class: CmpsDecimalPipe },
    CmpsPercentPipe: { identifier: 'CmpsPercentPipe', class: CmpsPercentPipe },
    InsightEpicBridge: {
        identifier: 'InsightEpicBridge',
        class: InsightEpicBridge,
    },
};

export default Types;
